import { requestGet } from '@/common/request';

export default function logout() {
  return requestGet('/logout');
}
